import type { IView } from '@barba/core';
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import aboutPageHandlers from '@/inits/pages/about/about-page-handlers';
import articleVideos from '@/inits/article-videos';
import initPageAnimations from '@/animations/pages/about/init-page-animations';

const beforeEnterQueue = new IdleQueue();

let observer: IntersectionObserver | null;

export default {
    namespace: 'about-page',

    beforeEnter({ next }) {
        beforeEnterQueue.pushTask(() => {
            aboutPageHandlers.init();
            articleVideos.init();
        });

        beforeEnterQueue.pushTask(() => {
            initPageAnimations.init();
        });

        const sections = Array.from(next.container.querySelectorAll<HTMLElement>('.js-about-section'));

        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const target = entry.target as HTMLElement;
                    target.style.visibility = entry.isIntersecting ? '' : 'hidden';
                });
            },
            { rootMargin: '200px 0px 200px 0px' },
        );

        sections.forEach((section) => {
            observer?.observe(section);
        });
    },

    beforeLeave() {
        aboutPageHandlers.destroy();
        articleVideos.destroy();
        initPageAnimations.destroy();

        if (observer) {
            observer.disconnect();
            observer = null;
        }
    },
} as IView;
